import React from "react";

export default function FooterAdminSection({
  lang,
  footerContent,
  handleFooterChange,
  saveFooterContent
}) {
  if (!footerContent) return null;

  return (
    <section className="section">
      <h2 className="sectionTitle">Footer ({lang})</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          name="description"
          value={footerContent.description || ""}
          onChange={handleFooterChange}
          placeholder="Descripción"
          className="input"
        />
        <input
          name="copyright"
          value={footerContent.copyright || ""}
          onChange={handleFooterChange}
          placeholder="Copyright"
          className="input"
        />
        <button
          onClick={saveFooterContent}
          className="button"
          style={{ alignSelf: "flex-start", marginTop: "0.5rem" }}
        >
          Guardar Footer
        </button>
      </div>
    </section>
  );
}